import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Box, Button, TextareaAutosize, Typography } from '@mui/material';

import { AppDispatch } from '../../../../app/store';
import { useCaseLock } from '../../../../common/caseLocking/CaseLockContext';
import { FlexCol, FlexRow } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import { SnackbarContext } from '../../../layout/SnackbarContext';
import { updateTaskData } from '../../../tasks/slice/taskThunks';
import styles from '../../styles.module.scss';

export const TaskNote = ({
  taskID,
  originalNote,
  label,
  readOnly,
}: {
  taskID: number;
  originalNote: string | undefined;
  label?: string;
  readOnly?: boolean;
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { id: applicationId } = useParams<{ id: string }>();
  const { isLockedForActions } = useCaseLock();
  const { openSnacks, setSnacks } = useContext(SnackbarContext);
  const isReadOnly = readOnly || isLockedForActions;
  const updateSnacks = (updatedSnacks: any) => {
    setSnacks(updatedSnacks);
  };

  const [noteEditingMode, setNoteEditingMode] = React.useState(false);
  const [note, setNote] = React.useState('');

  const handleTaskUpdate = () => {
    if (!applicationId) {
      return;
    }
    dispatch(
      updateTaskData(applicationId, taskID, { note }, openSnacks, updateSnacks),
    );
  };

  return (
    <>
      <FlexRow className={styles.MarginTop}>
        <FlexCol sm={3} className={styles.TaskLeftCell}>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {label ?? Resource.NOTE}
          </Typography>
        </FlexCol>

        <FlexCol className={styles.TaskWidth}>
          <Box ml={1.5} width="100%">
            {originalNote ? (
              <Typography
                variant="body2"
                component="pre"
                sx={{
                  margin: 0,
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {originalNote}
              </Typography>
            ) : isReadOnly ? null : noteEditingMode ? (
              <Box position="relative" width="80%">
                <Box position="absolute" bottom="1rem" right="0.6rem">
                  <Button
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={handleTaskUpdate}
                  >
                    <Typography variant="subtitle1">Submit</Typography>
                  </Button>
                </Box>
                <TextareaAutosize
                  name="approx_lab_date"
                  data-tid="approxlabdate-textarea"
                  placeholder="Describe the reason"
                  className={styles.TextareaInput}
                  onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => {
                    setNote(ev.currentTarget.value);
                  }}
                  value={note}
                  minRows={3}
                />
              </Box>
            ) : (
              <Button
                variant="outlined"
                disableElevation
                onClick={() => setNoteEditingMode(true)}
              >
                <Typography variant="subtitle2" color="textSecondary">
                  {Resource.ADD_NOTE}
                </Typography>
              </Button>
            )}
          </Box>
        </FlexCol>
      </FlexRow>
    </>
  );
};
